<template>
    <div class="event-list">
        <gcmcn-filters
            :filter-values="[selectedSortType, searchFilter, selectedUniversesForFilter, selectedEntitiesForFilter]"
            @reset-filters="resetFilters"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="$store.getters.sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="$store.getters.entities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntity"
            ></dropdown>
            <dropdown
                name="Universes"
                :multiple="true"
                :list="filteredUniverses"
                itemName="name"
                itemValue="uid"
                :itemsSelected="selectedUniversesForFilter"
                @on-select-item="onSelectUniverses"
            ></dropdown>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <div
            ref="events-container"
            class="events-container"
            :style="{height: `calc(100vh - ${this.eventListHeight}px)`}"
            style="padding-bottom: 20px;"
            v-scroll-to="$route.params.eventUid"
        >
            <template v-if="eventsFilterd.length > 0">
                <eventCard
                    v-for="event in eventsFilterd"
                    :key="event.uid"
                    :event="event"
                    :universe="eventUniverse(event.universe_uid)"
                    :selectedEventUid="selectedEventUid"
                    @changeSelectedEvent="changeSelectedEvent"
                ></eventCard>
            </template>
            <template v-else>
                <div class="list-empty">No event</div>
            </template>
        </div>
    </div>
</template>

<script>

import eventCard from './eventCard.vue';
import { mapGetters } from 'vuex'
import {
    GcmcnFilters,
    Dropdown,
    SearchFilter
} from 'gcmcn-common';

export default {

    components: {
        eventCard,
        GcmcnFilters,
        Dropdown,
        SearchFilter,
    },

    props: {
        events: {
            type: Array,
            required: true,
        },
        universes: {
            type: Array,
            required: true,
        },
        selectedEventUid: {
            type: String,
            required: true,
        }
    },
    data: function(){
        return {
            selectedSortType: 'asc',
            searchFilter: '',
        };
    },

    computed: {
        ...mapGetters([
            'selectedEntitiesForFilter',
            'selectedUniversesForFilter'
        ]),
        filteredUniverses(){
            if(this.selectedEntitiesForFilter.length > 0){
                let universes = [...this.universes];
                let filteredUniverses = universes.filter(universe=>{
                    return  this.selectedEntitiesForFilter.includes(universe.scopes.entity_uid);

                });
                return filteredUniverses;
            }
            return this.universes;
        },
        eventsFilterd (){
            let events = this.events.slice();
            if(this.selectedSortType){
                events.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    events.reverse();
                }
            }
            if(this.selectedEntitiesForFilter.length > 0){
                events = events.filter((event) => this.selectedEntitiesForFilter.includes(event.scopes.entity_uid));
            }
            if(this.searchFilter){
                events = events.filter((ev) => ev.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            if(this.selectedUniversesForFilter.length > 0){
                events = events.filter((ev) => this.selectedUniversesForFilter.includes(ev.universe_uid));
            }
            return events;

        },
        eventListHeight (){
            return this.$store.getters.pageHeight + 83; // 83 -> filters height
        }
    },
    watch:{
        selectedEntitiesForFilter(){
            let filteredUniversesUid = this.filteredUniverses
            .map(universe=>{
                return  universe.uid;

            });
            let selectedUniverseUids = this.selectedUniversesForFilter.filter(uid =>{
                return filteredUniversesUid.includes(uid);
            });
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', selectedUniverseUids);
        }
    },
    mounted (){
    },
    methods: {
        eventUniverse(universeUid) {
            if (!this.universes.length) {
                return {};
            } else {
                return this.universes.find(universe => universe.uid === universeUid);
            }
        },
        onDataFetched(data) {
            this.events = data.events;
            this.universes = data.universes;
        },
        changeSelectedEvent(uid) {
            this.$emit('changeSelectedEvent', this.events.find(event => event.uid === uid));
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
            this.$store.commit('CLEAR_ALL_FILTERS');

        },
        onSelectUniverses (universes){
            this.$store.commit('SET_UNIVERSES_FOR_FILTER', universes);
        },
        onSelectEntity (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
    },
};
</script>

<style lang="scss">
.event-list {
    .column-title {
        color: #AAA;
    }
    .events-container{
        overflow: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Events/eventList.vue